export const StatusBadgeComponent = {
  bindings: {
    label: '<',
    state: '<',
  },
  templateUrl: 'components/status-badge/status-badge.html',
};
